import { render, staticRenderFns } from "./MobileGesture.vue?vue&type=template&id=06fa400c&scoped=true&"
import script from "./MobileGesture.vue?vue&type=script&lang=ts&"
export * from "./MobileGesture.vue?vue&type=script&lang=ts&"
import style0 from "./MobileGesture.vue?vue&type=style&index=0&id=06fa400c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa400c",
  null
  
)

export default component.exports